




















import { namespace } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CART } from '@/store/types';
import BestFriendSection from '@/cart-page/cart/section/BestFriendSection.vue';
import ProductSection from '@/cart-page/cart/section/ProductSection.vue';
import PromotedProductSection from '@/cart-page/cart/section/PromotedProductSection.vue';

const cart = namespace(CART);

@Component({
  components: {
    PromotedProductSection,
    ProductSection,
    BestFriendSection,
  }
})
export default class CartStepView extends Vue {

  @Prop({required: false, default: 'false'})
  public localShowBestFriendMenu: string;
  @Prop({required: false, default: null})
  public localOrderTemplateList: string;

  get showBestFriendMenu() {
    return this.localShowBestFriendMenu === 'true';
  }
}
